import { Box, styled } from "@mui/material";

const Container = styled(Box)(({ theme }) => ({
  backgroundColor: "white",
  padding: theme.spacing(2),
  height: "92vh",
}));

export { Container };
